import { IconChevronLeft } from "@tabler/icons-react";
import { StyledActionIcon } from "src/styled";
import { Button } from "../Button/Button";
import { useGoBack } from "./useGoBack";

export const BackButton = ({
  onClick,
  label,
  fallback,
}: {
  onClick?: () => void;
  label?: string;
  fallback?: string;
}) => {
  const goBack = useGoBack(fallback);

  const handleGoBack = () => {
    if (onClick) {
      onClick();
    } else {
      goBack();
    }
  };

  return label && label.trim() !== "" ? (
    <Button
      variant="outline"
      onClick={handleGoBack}
      leftSection={<IconChevronLeft />}>
      {label}
    </Button>
  ) : (
    <StyledActionIcon data-cy="back-button" size="lg" onClick={handleGoBack}>
      <IconChevronLeft size="1.5rem" />
    </StyledActionIcon>
  );
};
